<template>
  <el-dialog
    :title="
      model.id
        ? `编辑 ${commodityCategory.name} 入库`
        : `添加 ${commodityCategory.name} 入库`
    "
    :visible.sync="visible"
    width="450px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="材料信息" prop="commodity_id">
        <CommoditySelect
          v-model="model.commodity_id"
          :category="model.commodity_category"
          v-if="model.created"
        ></CommoditySelect>
        <!-- <el-select
          size="small"
          placeholder="请搜索零件编码或名称"
          filterable
          remote
          :remote-method="getItems"
          :loading="loading"
          v-model="model.item_id"
        >
          <el-option
            v-for="item in items"
            :key="item.id"
            :label="`${item.name}（${item.code}）`"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="新 / 旧" prop="category">
        <el-select v-model="model.category" style="width: 100%" disabled>
          <el-option key="1" label="新" :value="1"></el-option>
          <el-option key="2" label="旧" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="供应方" prop="supplier">
        <el-input v-model="model.supplier"></el-input>
      </el-form-item>
      <el-form-item label="到货日期" prop="arrive_date">
        <el-date-picker
          v-model="model.arrive_date"
          type="date"
          placeholder="选择日期"
          style="width: 100%"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到货批次" prop="arrive_batch">
        <el-input v-model="model.arrive_batch"></el-input>
      </el-form-item> -->
      <el-form-item label="数量" prop="number">
        <el-input-number
          v-model="model.number"
          :min="1"
          :max="1000000"
        ></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="单价" prop="price">
        <el-input-number
          v-model="model.price"
          :precision="2"
          :step="0.5"
          :min="0"
          :max="100000"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="税率" prop="tax_rate">
        <el-input-number
          v-model="model.tax_rate"
          :precision="1"
          :step="0.1"
          :min="0"
          :max="100"
        ></el-input-number>
      </el-form-item> -->
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="model.remark"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  itemInRecordNew,
  itemInRecordUpdate,
  itemList,
} from '@/service/getData'

import CommoditySelect from './select/commodity_select.vue'

export default {
  components: {
    CommoditySelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    commodityCategory: {
      type: Object,
      default() {
        return {
          id: 0,
          name: '',
        }
      },
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      visible: this.show,
      rules: {
        commodity_id: [{ required: true, message: '请选择零件' }],
        item_id: [{ required: true, message: '请选择零件' }],
        arrive_batch: [{ required: true, message: '请填写到货批次' }],
      },
    }
  },
  methods: {
    async getItems(query) {
      if (query !== '') {
        this.loading = true
        let res = await itemList({ query: query })
        if (res.status == 0) {
          this.items = res.data.list
          this.loading = false
        }
      } else {
        this.items = []
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await itemInRecordUpdate(data)
            if (res.status == 0) {
              this.$emit('callback', res.data)
            }
          } else {
            let res = await itemInRecordNew(data)
            if (res.status == 0) {
              this.$emit('callback', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>